// components/problems/problems-search-bar.tsx
import { Search } from 'lucide-react'

interface ProblemsSearchBarProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export function ProblemsSearchBar({
  value,
  onChange,
  placeholder = 'Search questions',
}: ProblemsSearchBarProps) {
  return (
    <div className="relative mr-2 max-w-xs flex-1">
      <Search className="text-muted-foreground absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="problems-table-search bg-muted/50 border-border w-full rounded-md border py-2 pl-9 pr-3 text-sm"
      />
    </div>
  )
}
